import type { FaireProductEntity } from "../../entity_types/product";

export const p_5y9d67297n: FaireProductEntity = {
  token: "p_5y9d67297n",
  type: "product",
  name: "Star and Moon Gemstone 30 Pcs. .",
  brandToken: "b_6l28vptlbv",
  brandName: "Puka Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/c930a530b1c3167b3dc9ddbe3a56295c5634e24428f3e8c3a5c7bc9d9c8ba64c.webp",
  galleryImageUrls: [],
  priceDollars: 2.08,
  description:
    "Explore the celestial beauty of Star and Moon Gemstone from Puka Creations. This set of 30 spiritual stones is carefully selected, embodying the tranquility of the cosmos. Ideal for your spiritual needs, these gemstones from Puka Creations, a trusted name in trendy jewelry, gifts, toys, and accessories since 1992.",
  tags: [],
  msrpDollars: 5.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:46.343Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
